import {Injectable} from "@angular/core";
import {Response, ResponseOptions, Headers} from "@angular/http";
import {MockBackend, MockConnection} from "@angular/http/testing";
import {
  LOGIN_API_URL,
  RESET_PASSWORD_API_URL,
  RENEW_PASSWORD_API_URL,
  SET_PASSWORD_WITH_TOKEN_API_URL,
  VALIDATE_TOKEN_API_URL,
  GET_USER_DETAILS
} from "./login/api";

@Injectable()
export class MyBackendService extends MockBackend {
  public constructor() {
    super();
  }

  start() {
    this.connections.subscribe((c: MockConnection) => {
      switch (c.request.url) {
        case LOGIN_API_URL:
          setTimeout(() => {
            // c.mockError(<any>new Response(
            //   new ResponseOptions({
            //     headers: new Headers({"Set-Cookie": "login=JWT-TOKEN"}),
            //     //status: 200
            //     //status: 401, body: { statusMessage: 'Wrong username or password' }
            //     status: 401,
            //     body: {
            //       result: "failure",
            //       reason: "UserLockedFailure",
            //       prettyReason: "password expired - password change required",
            //       lockedUntil: "2018-10-14T14:01:18.849Z"
            //     }
            //   })
            // ));
            c.mockRespond(new Response(new ResponseOptions({
              status: 200,
              body: {"user_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyTmFtZSI6InNoYWxvbS5oYWRheWFAdmF0Ym94LmNvbSIsImV4cGlyZXNUUyI6MTUzOTk1MDA5OTE4MywidG9rZW5JZCI6eyIkb2lkIjoiNWJjODc0OTM3YzE4YWQwMDAxN2M0YTRmIn19.Uh-is0xwO673kmTUT0KFnwLHTP8O95GSAGDYLCKwgEQ"}
            })));
          }, 500);
          break;

        case RESET_PASSWORD_API_URL:
          setTimeout(() => {
            c.mockRespond(
              new Response(
                new ResponseOptions({
                  headers: new Headers({"Content-Type": "application/json"}),
                  status: 200
                })
              )
            );
            // c.mockError(<any>new Response(
            //   new ResponseOptions({
            //     headers: new Headers({'Content-Type': 'application/json'}),
            //     status: 400,
            //     body: {errors: ["you used that password before", "too short password"]}
            //   })));
          }, 500);
          break;

        case RENEW_PASSWORD_API_URL:
          setTimeout(() => {
            c.mockRespond(
              new Response(
                new ResponseOptions({
                  headers: new Headers({"Content-Type": "application/json"}),
                  status: 200
                })
              )
            );
          }, 500);
          break;

        case VALIDATE_TOKEN_API_URL:
          setTimeout(() => {
            if (JSON.parse(c.request.getBody()).token === "mockToken") {
              c.mockRespond(
                new Response(
                  new ResponseOptions({
                    headers: new Headers({
                      "Content-Type": "application/json"
                    }),
                    status: 200
                  })
                )
              );
            } else {
              c.mockError(<any>new Response(
                new ResponseOptions({
                  headers: new Headers({"Content-Type": "application/json"}),
                  status: 400
                })
              ));
            }
          }, 500);
          break;

        case SET_PASSWORD_WITH_TOKEN_API_URL:
          setTimeout(() => {
            c.mockRespond(
              new Response(
                new ResponseOptions({
                  headers: new Headers({"Content-Type": "application/json"}),
                  status: 200
                })
              )
            );
          }, 500);
          break;

        case GET_USER_DETAILS:
          c.mockRespond(
            new Response(
              new ResponseOptions({
                headers: new Headers({
                  "Content-Type": "application/json"
                }),
                status: 200,
                body: {
                  _id: '1234',
                  firstName: 'erez',
                  lastName: 'baba',
                  email: 'asdf@asdf.com',
                  active: true,
                  accountId: '1234',
                  label: 'mona',
                  previousLogin: '2018-10-14T14:01:18.849Z',
                  skills: [
                    {
                      type: 'asdf',
                      values: []
                    }
                  ],
                  extra: {
                    superGroupsIds: [],
                    modules: [],
                    roles: []
                  }
                }
              })
            )
          );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/services/my-backend.ts